import axios from 'axios';
import { Message } from 'view-ui-plus';
import util from '@/utils/util';
import router from '@/router'

const http = axios.create({
    baseURL: process.env.VUE_APP_HTTP_BASE_URL, // 基础URL
    timeout: 60000, // 请求超时时间 60s

});

// 请求拦截器
http.interceptors.request.use(
    config => {
        // 可以在这里添加认证token等
        // if (store.getters.token) {
        //   config.headers['Authorization'] = `Bearer ${store.getters.token}`;
        // }
        const userInfoItem = localStorage.getItem('userInfo');
        if(userInfoItem && userInfoItem != "undefined" && userInfoItem != "null"){
            config.headers['token'] = JSON.parse(userInfoItem).token;
        }
        return config;
    },
    error => {
        // 请求错误处理
        return Promise.reject(error);
    }
);

// 响应拦截器
http.interceptors.response.use(
    response => {
        // 对响应数据做处理，只返回响应码为200的数据
        let responseData = response.data;
        if(responseData && responseData.code === 200){
            return responseData.obj;
        }else if(responseData.code === 101){
            // 未登录
            const autoLogin = util.getLocalStorage('autoLogin');
            const userInfo = util.getLocalStorage('userInfo');
            if(autoLogin===true && userInfo && userInfo != 'undefined' && userInfo != 'null'){
                // 勾选了自动登录且本地有token则调用自动登录
                http.post('/login/loginById', {})
                .then((resp)=>{
                    util.setLocalStorage('userInfo', resp);
                    router.push({name: 'index'});
                })
                .catch((err)=>{
                    // 清除本地存储, 否则在自动登录失败的情况下会重复调用自动登录接口
                    localStorage.removeItem('userInfo');
                })
            }else{
                // 跳转登录界面
                localStorage.removeItem('userInfo');
                if(!userInfo){
                    Message.error(responseData.msg);
                }
                setTimeout(function () {
                    window.location.href = '/';
                }, 1500);
            }
        }else{
            // 其他的响应码直接弹出错误提示
            Message.error(responseData.msg || '服务器忙, 请稍后再试');
            return Promise.reject(responseData.msg || '服务器忙, 请稍后再试');
        }
    },
    error => {
        // 响应错误处理 HttpStatus != 200直接弹出错误提示, 注意: 仍然会进catch
        Message.error('请求失败, 请检查网络');
        return Promise.reject(error);
    }
);

export default http;
